export function hasFetch(): boolean {
  return typeof fetch === 'function';
}

export function hasWindow(): boolean {
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

export function hasKeepalive(): boolean {
  if (typeof Request === 'undefined') return false;
  try {
    return 'keepalive' in new Request('https://example.com');
  } catch {
    return false;
  }
}

export function hasBeacon(): boolean {
  return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
}

export function hasAbortController(): boolean {
  return typeof AbortController === 'function';
}

export function joinPath(base: string, path: string): string {
  const b = base.endsWith('/') ? base.slice(0, -1) : base;
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${b}${p}`;
}
